import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import dateFormat from 'dateformat';
// TODO: https://github.com/mui/mui-x/issues/4644
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { stopShipment } from '#action/shipment/overview';
import propTypes from './prop-types';
import { getDateTimeFormat } from '#helper';

const DeleteDialog = props => {
  const {
    shipment: { delivery },
    shipment,
    dispatch,
    showDialog,
    setShowDialog
  } = props;

  const measurementSystem = useSelector(s => s.account.measurementSystem);
  const [error, setError] = useState(null);
  const [stopDate, setStopDate] = useState(new Date());

  const formatFns = useMemo(() => getDateTimeFormat(measurementSystem, 'dateTimeShortDateFns'), [measurementSystem]);
  const dateTimeFormat = useMemo(() => getDateTimeFormat(measurementSystem, 'dateTimeShort'), [measurementSystem]);

  const handleClose = () => {
    setShowDialog(false);
  };

  const handleOk = () => {
    setShowDialog(false);
    dispatch(stopShipment(shipment.id, { stopDate }));
  };

  const getMinDate = () => {
    if (delivery.length === 0) {
      const today = new Date();
      const minDate = new Date(today.setMonth(today.getMonth() - 3)).toISOString();
      return minDate;
    }

    const minDate = delivery.reduceRight((acc, rec, i) => {
      if (acc) return acc;
      if (rec.done) {
        return rec.done;
      }
      if (rec.date < new Date().toISOString() || i === 0) {
        return rec.date;
      }
      return acc;
    }, '');
    return minDate;
  };

  const minDate = getMinDate();

  const handleDateChange = date => {
    if (error) {
      setError(null);
    }

    if (Date.parse(date)) {
      if (minDate && date.toISOString() < minDate) {
        setError(`Must be after ${dateFormat(minDate, dateTimeFormat)}`);
      } else if (date > new Date()) {
        setError(`Must be earlier than ${dateFormat(new Date(), dateTimeFormat)}`);
      }
      setStopDate(date);
    } else {
      setError('Invalid date format');
    }
  };

  return (
    <Dialog
      open={showDialog}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>
        Stop shipment
      </DialogTitle>
      <DialogContent>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DesktopDatePicker
            label="Stop date"
            inputVariant="outlined"
            format={formatFns}
            value={new Date(stopDate)}
            onChange={handleDateChange}
            minDate={new Date(minDate)}
            maxDate={new Date()}
            strictCompareDates
            disabled={new Date(minDate) > new Date()}
            slotProps={{
              textField: {
                error: !!error,
                helperText: error
              }
            }}
          />
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleOk} color="primary" autoFocus disabled={!!error}>
          Stop
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteDialog.propTypes = propTypes;

export default DeleteDialog;
